var _path, _g, _path2, _g2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPersonalMedicalHistoryActive = function SvgPersonalMedicalHistoryActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5854_8647",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 16,
    width: 18,
    height: 9
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 16.1719H23V24.3366H5V16.1719Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5854_8647)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0006 17.832C9.15882 17.832 6.70442 18.6425 6.70442 20.2423C6.70442 21.8565 9.15882 22.6747 14.0006 22.6747C18.8412 22.6747 21.2945 21.8643 21.2945 20.2644C21.2945 18.6502 18.8412 17.832 14.0006 17.832ZM14.0011 24.3366C11.7749 24.3366 4.99988 24.3366 4.99988 20.2431C4.99988 16.5937 10.1374 16.1719 14.0011 16.1719C16.2272 16.1719 23 16.1719 23 20.2653C23 23.9147 17.8636 24.3366 14.0011 24.3366Z",
    fill: "#3175F6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5854_8647",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 2,
    width: 14,
    height: 13
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.96558 2.33594H20.0331V14.0923H7.96558V2.33594Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5854_8647)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0008 3.91602C11.568 3.91602 9.58856 5.84357 9.58856 8.21398C9.5806 10.5766 11.5453 12.5031 13.9678 12.5119L14.0008 13.3025V12.5119C16.4325 12.5119 18.4108 10.5833 18.4108 8.21398C18.4108 5.84357 16.4325 3.91602 14.0008 3.91602ZM14.0005 14.0928H13.9641C10.6439 14.0828 7.95425 11.4445 7.96561 8.2116C7.96561 4.97318 10.6723 2.33594 14.0005 2.33594C17.3276 2.33594 20.0331 4.97317 20.0331 8.21492C20.0331 11.4567 17.3276 14.0928 14.0005 14.0928Z",
    fill: "#3175F6"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPersonalMedicalHistoryActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/personal_medical_history_active.464644b4.svg";
export { ForwardRef as ReactComponent };